module.exports = __webpack_public_path__ + "img/new-index-apply-dd.186e2b0c.png";